import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';

import { LayoutTheme as EditComponent } from '../../tsx/LayoutTheme';

export class LayoutThemeField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {
            noTitle: true
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal: any = '', options?, directionOptions?) {
        super(glob, title, LayoutThemeField.defaultValidators, validators, defaultVal, options, directionOptions);
    }
}
